import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { RecommendedBookCard } from '@/components/recommended-book-card';
import { Book } from '@/types/models';
import { BookOpen } from 'lucide-react';
import { useTranslations } from '@/hooks/use-translations';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';

interface RecommendedBooksSliderProps {
    books: Book[];
}

export function RecommendedBooksSlider({ books }: RecommendedBooksSliderProps) {
    const { t } = useTranslations();
    
    if (!books || books.length === 0) {
        return null;
    }

    return (
        <section className="py-16 bg-muted/50">
            <div className="container mx-auto px-4">
                <div className="mx-auto max-w-6xl">
                    <div className="mb-12 flex items-center gap-4">
                        <BookOpen className="h-5 w-5 text-muted-foreground" />
                        <h2 className="text-2xl font-medium">{t('Recommended Books')}</h2>
                        <div className="flex-1 h-px bg-border" />
                    </div>
                    
                    <div className="recommended-books-swiper">
                        <Swiper
                            modules={[Autoplay]}
                            spaceBetween={16}
                            slidesPerView={2}
                            autoplay={{
                                delay: 4000,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true,
                            }}
                            speed={1000}
                            loop={books.length > 5}
                            breakpoints={{
                                640: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                },
                                768: {
                                    slidesPerView: 4,
                                    spaceBetween: 24,
                                },
                                1024: {
                                    slidesPerView: 5,
                                    spaceBetween: 24,
                                },
                            }}
                            className="!pb-4"
                        >
                            {books.map((book) => (
                                <SwiperSlide key={book.id}>
                                    <div className="h-full">
                                        <RecommendedBookCard book={book} />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
}